import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------ English ------------------------------ */
i18next.addResources(locales.EN, 'DEATHS_FORM', {
  TITLE: 'Death Form',
  PERSON: 'Deceased',
  SPOUSE: 'Spouse',
  OTHER: 'Other data',
  CHILDREN: 'Children',
  LOCATION: 'Location',
  SIGNERS: 'Signers',
  SIGNER: 'Signer',
  PAYMENT: 'Payment',
  COMMENTS: 'Comments',
  PERSON_INFORMATION: 'Deceased information',
  OTHER_INFORMATION: 'Other information',
  CHILDREN_INFORMATION: 'Children information',
  LOCATION_INFORMATION: 'Location information',
  SIGNERS_INFORMATION: 'Signers information',
  SIGNER_INFORMATION: 'Signer information',
  PAYMENT_INFORMATION: 'Payment information',
  NAME: 'First name',
  LAST_NAME: 'Last name',
  ID_CARD_TYPE: 'ID Card type',
  ID_CARD: 'ID Card',
  ID_CARD_FILE: 'ID Card front file (scanned)',
  ID_CARD_BACK_FILE: 'ID Card back file (scanned)',
  AGE: 'Age',
  COUNTRY: 'Country',
  ADDRESS: 'Address',
  BIRTHDATE: 'Birthdate',
  DEATH_DATE: 'Death date',
  DEATH_PLACE: 'Death place',
  DEATH_DATE_HEBREW: 'Death date in Hebrew',
  COMMUNITY: 'Community',
  CIVIL_STATE: 'Civil state',
  TRIBE: 'Cohen, Levi or Israel',
  KETUBA_FILE: 'Ketubá',
  MARRIAGE_CERTIFICATE_FILE: 'Marriage certificate',
  GET_FILE: 'Get',
  WEDDING_TEMPLE: 'Wedding temple',
  ALIVE: 'Is alive?',
  CEMENTERY: 'Cemetery',
  FATHER_INFO: 'Father information (indicate if they live or not, and cemetery if applicable)',
  MOTHER_INFO: 'Mother information (indicate if they live or not, and cemetery if applicable)',
  CEMENTERIES: 'Cementeries',
  CHILDREN_INFO: 'Names, last names, civil state and with whom they are married',
  PLOT: 'Plot',
  SIGNER_NAME: 'Signer name',
  AREA_CODE: 'Area code',
  PHONE: 'Phone',
  TELEPHONE: 'Telephone',
  EMAIL: 'Email',
  RELATIONSHIP: 'Relationship with the deceased',
  KINSHIP: 'Kinship',
  CURRENCY: 'Currency',
  AMOUNT: 'Amount',
  PAYMENT_CONDITIONS: 'Payment conditions',
  PAYMENTS_DONE: 'Payments done',
  GARAGE: 'Garage',
  SUBMIT_BUTTON: 'Submit',
  LOADING: 'Loading...',
  SECTOR_OLD: 'Viejo',
  SECTOR_ANNEX: 'Anexo',
  SECTOR_CANNING: 'Canning',
});

/* ------------------------------ Spanish ------------------------------ */
i18next.addResources(locales.ES, 'DEATHS_FORM', {
  TITLE: 'Formulario de fallecimiento',
  PERSON: 'Fallecido/a',
  SPOUSE: 'Cónyuge',
  OTHER: 'Otros datos',
  CHILDREN: 'Hijos',
  LOCATION: 'Ubicación',
  SIGNERS: 'Firmantes',
  SIGNER: 'Firmante',
  PAYMENT: 'Pago',
  COMMENTS: 'Observaciones',
  PERSON_INFORMATION: 'Información del fallecido/a',
  SPOUSE_INFORMATION: 'Información del cónyuge',
  OTHER_INFORMATION: 'Otros datos del fallecido/a',
  CHILDREN_INFORMATION: 'Información de los hijos',
  LOCATION_INFORMATION: 'Ubicación de la reserva',
  SIGNERS_INFORMATION: 'Información de los firmantes',
  SIGNER_INFORMATION: 'Información del firmante',
  PAYMENT_INFORMATION: 'Información de pago',
  NAME: 'Nombre',
  LAST_NAME: 'Apellido',
  ID_CARD_TYPE: 'Tipo de documento',
  ID_CARD: 'Documento',
  ID_CARD_FILE: 'Documento frente (escaneado)',
  ID_CARD_BACK_FILE: 'Documento dorso (escaneado)',
  AGE: 'Edad',
  ADDRESS: 'Domicilio',
  COUNTRY: 'País',
  BIRTHDATE: 'Fecha de nacimiento',
  DEATH_DATE: 'Fecha de fallecimiento',
  DEATH_PLACE: 'Lugar de fallecimiento',
  DEATH_DATE_HEBREW: 'Fecha de fallecimiento en hebreo',
  COMMUNITY: 'Comunidad',
  CIVIL_STATE: 'Estado civil',
  TRIBE: 'Cohen, Levi o Israel (Si dudas, elegí Israel)',
  KETUBA_FILE: 'Ketubá',
  MARRIAGE_CERTIFICATE_FILE: 'Libreta de casamiento',
  GET_FILE: 'Get',
  WEDDING_TEMPLE: 'Templo donde se casó',
  ALIVE: 'Está vivo?',
  CEMENTERY: 'Cementerio',
  FATHER_INFO: 'Nombre y apellido del padre (indicar si vive o no, y cementerio si corresponde)',
  MOTHER_INFO: 'Nombre y apellido de la madre (indicar si vive o no, y cementerio si corresponde)',
  CEMENTERIES: 'Cementerios',
  CHILDREN_INFO: 'Nombres, apellidos, estado civil y con quién están casados',
  PLOT: 'Parcela',
  SIGNER_NAME: 'Nombre y apellido del firmante',
  AREA_CODE: 'Código de área',
  PHONE: 'Celular',
  TELEPHONE: 'Teléfono de línea',
  EMAIL: 'Email',
  RELATIONSHIP: 'Relación con el fallecido/a',
  KINSHIP: 'Parentesco',
  CURRENCY: 'Moneda',
  AMOUNT: 'Importe',
  PAYMENT_CONDITIONS: 'Condiciones de pago',
  PAYMENTS_DONE: 'Pagos realizados',
  GARAGE: 'Cochería',
  SUBMIT_BUTTON: 'Enviar',
  LOADING: 'Cargando...',
  SECTOR_OLD: 'Viejo',
  SECTOR_ANNEX: 'Anexo',
  SECTOR_CANNING: 'Canning',
});
